import React from 'react'
import SideNav from '../../components/SideNav'
import MainDashboard from '../../components/admin/Dashboard'
import Header from '../../components/Header'
import ITCApplicants from '../../components/admin/ITCApplicants'
export default function Applicants() {
  return (
    <>
    <Header/>
    <SideNav/>
    <ITCApplicants/>
    </>
  )
}
